import React from "react";

const BusinessWrapper = ({content}) => {
  if (content.fieldCompany || content.fieldPosition) {
    return (
      <div className="business-wrapper text body-m">
          {content.fieldCompany &&
            <span
              className="company body-m"
              dangerouslySetInnerHTML={{ __html: `${content.fieldCompany}${content.fieldPosition ? ' / ' : ''}` }}
            />
          }
          {!!content.fieldPosition && (
            <span
              className="position body-m"
              dangerouslySetInnerHTML={{ __html: content.fieldPosition }}
            />
          )}

      </div>
    );
  } else {
    return false;
  }
};

export default BusinessWrapper;
